// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-Dqsq","inner":"styles_inner__Ibm1F","right":"styles_right__3JKFl","close":"styles_close__2MzLB","footer":"styles_footer__2J2Mn"};